export default __webpack_public_path__ + "static/media/Medium's Hood of Consumed Souls.0afa03ac.jpg";